import React, {useState} from 'react';
import {DocumentSelection, DocumentUpload} from '../../components';

export function DocumentPhoto() {
	const [documentType, setDocumentType] = useState('');

	function handleResend() {
		setDocumentType('');
	}

	return documentType ? (
		<DocumentUpload onResend={handleResend} />
	) : (
		<DocumentSelection onSelect={setDocumentType} />
	);
}
